function mtaInitial(sid, cid) {
  const mta = document.createElement('script')
  mta.src = '//pingjs.qq.com/h5/stats.js?v2.0.4'
  mta.setAttribute('name', 'MTAH5')
  mta.setAttribute('sid', sid)
  mta.setAttribute('cid', cid)
  const s = document.getElementsByTagName('script')[0]
  s.parentNode.insertBefore(mta, s)
}

export default mtaInitial
